import { createInstance, dateReviver } from '@/api';
import { PublicationClient, PublicationVersion } from '@/api/frontoffice/clients';
import { useAlertStore } from '@/modules/core/store/alert.store';
import { defineStore } from 'pinia';
import { i18n } from '@/i18n';
import downloadBlob from '@/helpers/download.helpers';

export interface PublicationVersionDetailStoreState {
    loading: boolean;
    publicationVersion: PublicationVersion;
}

export const client = new PublicationClient('', createInstance(), dateReviver);

export const usePublicationVersionDetailStore = defineStore('publications-publications-version-detail-store', {
    state: (): PublicationVersionDetailStoreState => ({
        loading: false,
        publicationVersion: null
    }),
    getters: {},
    actions: {
        async getPublicationVersion(publicationId: string, id: string): Promise<void> {
            this.loading = true;
            useAlertStore().clearAlert();
            try {
                const response = await client.getPublicationVersionDetail(publicationId, id);
                this.publicationVersion = response;
            } catch (error) {
                useAlertStore().handleException(
                    i18n.global.t('publications.versions.detail.error.title'),
                    error,
                    false
                );
            } finally {
                this.loading = false;
            }
        },
        async downloadDeliveryFile(publicationId: string, versionId: string): Promise<void> {
            if (!this.publicationVersion.deliveryRunGuid) {
                return;
            }
            const file = await client.getDeliveryFile(publicationId, versionId);

            return new Promise((resolve, reject) => {
                try {
                    downloadBlob(file.data, file.fileName, () => {
                        resolve();
                    });
                } catch (e) {
                    reject(e);
                }
            });
        },
        clear() {
            this.publicationVersion = null;
            this.loading = false;
            useAlertStore().clearAlert();
        }
    }
});
